/**
 * loadAssetBlob — where a Media Library thumbnail gets its bytes: this site's
 * OPFS bucket first, then a collab peer when free-mode collaboration is on.
 * `null` means neither has it, so the tile can say so instead of waiting
 * forever ("resolving…" used to stay up when no peer was there to answer).
 */
import { getAssetFile } from "./opfsAssetStore.js";
import { getCollabBlobResolver } from "./collabBlobResolver.js";

export async function loadAssetBlob(
  siteId: string,
  sha: string,
): Promise<Blob | null> {
  const local = await getAssetFile(siteId, sha);
  if (local) return local;
  const resolver = getCollabBlobResolver(siteId);
  if (!resolver) return null;
  const bytes = await resolver(sha);
  return bytes ? new Blob([bytes as BlobPart]) : null;
}
